import { ChangeDetectionStrategy, Component, signal, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog'
import { WorkItem, WorkItemState } from '../work-item'
import { WorkItemFilter } from '../work-item.service'
import { ConstraintInput } from '../../../shopfloor/workcenters/capability/constraints/constraintInput'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { ScheduleSelectRouteTableComponent } from '../schedule-select-route-table/schedule-select-route-table.component'
import { WorkItemUtilisationTableComponent } from '../../utilisation/work-items/work-item-table/work-item-utilisation-table.component'
import { MatIcon } from '@angular/material/icon'
import { MatIconButton, MatButton } from '@angular/material/button'
import { ElderThemeDirective } from '@elderbyte/ngx-starter'
import { MatToolbar } from '@angular/material/toolbar'

export interface IRouteSelectDialogMultiOptions {
  readonly workCenterId: string
  readonly workOrderId: string
  readonly itemConstraints: ConstraintInput[]
}

@Component({
  selector: 'app-route-select-dialog',
  templateUrl: './schedule-select-dialog-multi.component.html',
  styleUrls: ['./schedule-select-dialog-multi.component.scss'],
  imports: [
    MatToolbar,
    ElderThemeDirective,
    MatIconButton,
    MatDialogClose,
    MatIcon,
    MatButton,
    WorkItemUtilisationTableComponent,
    ScheduleSelectRouteTableComponent,
    ElderTranslatePipe,
  ],
})
export class ScheduleSelectDialogMultiComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly workCenterId = signal<string>(null)
  public readonly workOrderId = signal<string>(null)
  public readonly itemConstraints = signal<ConstraintInput[]>([])

  public readonly selectedItems = signal<WorkItem[]>([])
  public readonly showAllRoutes = signal<boolean>(false)

  public readonly modifiedItemsId = signal<string[]>([])

  public readonly itemFilter = WorkItemFilter.processingStates([WorkItemState.OPEN])

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const data = inject<IRouteSelectDialogMultiOptions>(MAT_DIALOG_DATA)
    this.workCenterId.set(data.workCenterId)
    this.workOrderId.set(data.workOrderId)
    this.itemConstraints.set(data.itemConstraints)
  }
}
